export enum StorePlatform {
    appleStore = "appleStore",
    googlePlatform = "googlePlatform",
}